import type { Consent, ConsentKind } from '../types/app'

export type ConsentState = 'granted' | 'withdrawn' | 'not_recorded'

// The API returns consent history newest first (created_at DESC, id DESC), so
// the first row of a kind is the one that stands. Reading the last row
// instead would show a withdrawal as still granted.
export function consentState(history: Consent[], kind: ConsentKind): ConsentState {
  const latest = history.find((c) => c.kind === kind)
  if (!latest) return 'not_recorded'
  return latest.granted ? 'granted' : 'withdrawn'
}
